import ManagerCard from './ManagerCard';

export default ManagerCard;



// WEBPACK FOOTER //
// ./src/scenes/Managers/components/ManagerCard/index.ts